// shared-lib/cabinet-runs/runEnds.js
//
// World points of a room's run terminal edges, keyed by run id — what
// `applyLinkAnchors` needs to resolve an `align-end` link whose target is
// ANOTHER run's end (the two arms of a U squaring their mouth; a peninsula
// meeting the wall run it grew from).
//
// One implementation for both callers. The web-app re-solve built this map
// itself and the server scan path never built it at all, so every run-end
// link was silently refused (`off-wall`) on each reprocess while working fine
// in the browser — a divergence neither side could see.

const { wallParamToSurfacePoint } = require('../kitchen-assembly/wallMath');
const { runAliases } = require('./runIds');

/**
 * @param {Object[]} runs  runs whose segments are RESOLVED — each wall-backed
 *   segment carries `wall`. Free-standing segments are skipped: a run end is a
 *   point on a wall, and an island has no wall to project onto.
 * @param {string} [exceptRunId]  omit this run (a run never targets itself)
 * @returns {Object<string, { start: {x,z}, end: {x,z} }>}
 */
function runEndsForResolvedRuns(runs, exceptRunId = null) {
  const out = {};
  for (const run of runs || []) {
    if (!run?.id || run.id === exceptRunId) continue;
    const wallSegs = (run.segments || []).filter(
      (s) => !s.freestanding && s.wall
    );
    if (!wallSegs.length) continue;
    const first = wallSegs[0];
    const last = wallSegs[wallSegs.length - 1];
    const start = wallParamToSurfacePoint(first.wall, first.startParam);
    const end = wallParamToSurfacePoint(last.wall, last.endParam);
    if (!start || !end) continue;
    // Published under the run's id AND every per-wall alias, so a link that
    // named `autorun_<wallB>` before the walls' runs joined still resolves.
    for (const id of [run.id, ...runAliases(run)]) {
      out[id] = { start, end };
    }
  }
  return out;
}

module.exports = { runEndsForResolvedRuns };
